import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService } from '@supoui/core/services/http.service';
import { IVideo } from '@supoui/help/models/video';
import { SERVER_API_URL } from '../../app.constants';
import {map, tap} from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class VideoService {
  private videos= new Map<number, IVideo>();
  private thumbnails = new Map<number,string>();

  constructor(private httpService: HttpService) {}

  public getVideos(langKey: string): Observable<IVideo[]> {
    return this.httpService.get<IVideo[]>(`services/supo-ui/video/${langKey}`).pipe(tap(videos => videos.forEach(v => this.videos.set(v.id, v))));
  }

  public getThumbnailBinary(fileName: string): Observable<Blob> {
    return this.httpService.get(`${SERVER_API_URL}services/supo-ui/video/thumbnail/${fileName}`, { responseType: 'blob' });
  }

  public getThumbnailUrl(id: number): string {

    if (!this.thumbnails.has(id) && this.videos.has(id)) {
      this.thumbnails.set(id, null);
      this.getThumbnailBinary(this.videos.get(id).thumbnail)
        .pipe(map(data => window.URL.createObjectURL(data)))
        .subscribe(url => this.thumbnails.set(id, url)
        );
    }
    return this.thumbnails.get(id);
  }

  public getVideoUrl(fileName: string): Observable<Blob> {
    return this.httpService.getVideo(`${SERVER_API_URL}services/supo-ui/video/stream/${fileName}`);
  }
}
